module.exports = __webpack_public_path__ + "sflyssofe.3c2f452c35.svg";